import styled from 'styled-components';
import headerbg from '../../../../public/image/whyUs/mobile/operationalintelligence/headerbg.webp';
import side from '../../../../public/image/whyUs/mobile/operationalintelligence/side.webp';

export const Wrapper = styled.div`
  height: ${(props) => (props.secHeight ? props.secHeight : 0) + 'px'};
  overflow: hidden;
  transition: 0.5s;
  margin-top: ${(props) => (props.secHeight > 0 ? '-7vh' : 0)};
  .intelligence__header {
    display: flex;
    justify-content: center;
    align-items: baseline;
    background-image: url(${headerbg.src});
    background-size: cover;
    background-position: center center;
    padding: 12vh 2vh 5vh;

    img {
      width: 300px;
      max-width: 60%;
    }
  }

  .intelligence__content {
    display: flex;
    margin-top: 5px;
    &__side {
      min-width: 20vw;
      background-image: url(${side.src});
      background-size: cover;
      background-position: top;
    }
    &__sectionWrapper {
      margin-left: -20%;

      &__icon {
        min-width: 20vw;
        text-align: center;
        padding-top: 15px;

        img {
          min-width: 60%;
        }
      }
      section {
        width: 100vw;
        display: flex;
        position: relative;

        &:after {
          content: '';
          width: 95%;
          left: 5%;
          border-bottom: 1px solid gray;
          position: absolute;
        }
      }

      &__text {
        padding: 35px 10px;
        &__title {
          font-size: 1.2rem;
          line-height: 2rem;
          color: #0b1c3c;
          font-weight: bold;
          font-family: 'poppinsBold';
          margin-bottom: 1rem;
          @media (min-width: 768px) {
            font-size: 1.4rem;
            line-height: 1.2rem;
          }
        }

        &__image {
          position: relative;
          z-index: 10;
          display: block;
          margin: -60px auto 15px;
        }

        &__paragraph {
          font-size: 1.5rem;
          text-align: justify;
          font-family: 'poppinsRegular';
          margin-right: 1rem;
          font-size: 0.8125rem;
          @media (min-width: 768px) {
            font-size: 1.3333333rem;
          }
          @media (max-width: 390px) {
            @supports (-webkit-touch-callout: none) {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
  }

  .darkblue {
    color: #0b1c3c;
    font-family: 'poppinsBold';
  }
  .bold {
    font-weight: bolder;
  }
`;
